module.exports = __webpack_public_path__ + "img/bg_imgd.8bf0f313.png";